export default __webpack_public_path__ + "static/media/crushingonslaught.5179e178.png";